import React, { useState } from "react";
import {
  Card, CardBody, CardHeader, Col, Container, Row, Nav, NavItem, NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import ResearchDisclaimer from "../../Components/Common/ResearchDisclaimer";
import Scorecard from "./Scorecard";

/**
 * The scorecard on a page of its own.
 *
 * It used to sit above the research list, where it grew to several cards deep —
 * one per prompt style, each with a calibration table and a per-model breakdown
 * — and pushed the actual research off the first screen. These are two different
 * visits: "what did I record" and "how am I doing". The list keeps a one-line
 * summary that links here.
 */

const SCOPES = [
  {
    id: "mine",
    label: "My research",
    hint: "How the forecasts you recorded have scored.",
  },
  {
    id: "shared",
    label: "Shared by members",
    hint: "Research other members chose to make public, scored the same way.",
  },
  {
    id: "all",
    label: "Everything I can see",
    hint: "Your own research and everything shared with you, together.",
  },
];

const ScorecardPage = () => {
  document.title = "Scorecard | ForecastNest";

  const [scope, setScope] = useState("mine");

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Scorecard" pageTitle="My Research" />
        <ResearchDisclaimer className="mb-3" />

        <Row className="justify-content-center">
          <Col xxl={9} xl={10}>
            <Card>
              <CardHeader className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Nav pills className="mb-0">
                  {SCOPES.map((s) => (
                    <NavItem key={s.id}>
                      <NavLink href="#" className={scope === s.id ? "active" : ""}
                               onClick={(e) => { e.preventDefault(); setScope(s.id); }}>
                        {s.label}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
                <Link to="/my-research" className="btn btn-sm btn-light">
                  <i className="ri-list-check align-bottom me-1" />Back to research
                </Link>
              </CardHeader>
              <CardBody>
                <p className="text-muted fs-13">
                  {SCOPES.find((s) => s.id === scope)?.hint}
                </p>
                <Scorecard scope={scope} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ScorecardPage;
